import React from 'react';

import { useAppSelector } from 'redux/hooks';
import { useParams } from 'react-router-dom';
import {withParamsFrame} from "../../HOCs";
import {IframePage} from "../../types/iframe";

const New: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);

    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    const { productId } = useParams()

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={'page-iframe'} src={`https://lk.market/${sellerId}/pim/edit/${productId}${httpParams}`}
                        title="Products"
                        width="100%"
                        height={"calc(100vh-64px)"}
                ></iframe>
            </div>
        </>
    );

}
export default withParamsFrame(New);
